import Vue from "vue";

export async function index(client_id) {

  const response = await Vue.prototype.$http.get(`clients/${client_id}/credit_transactions`);

  return response.data;
}